import {Icon} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'

interface CellBottleAndCaseAttrs {
    bottle_text: string
    case_text: string
    className?: string
}

export class CellBottleAndCase extends MithrilComponent<CellBottleAndCaseAttrs> {
    view(vnode: m.Vnode<CellBottleAndCaseAttrs>) {
        return (
            <div className={classes(vnode.attrs.className, 'c-quantity')}>
                {Boolean(vnode.attrs.bottle_text) && (
                    <div className='bottle-quantity'>
                        <Icon name='bottle' size='s' type='unset' />
                        {vnode.attrs.bottle_text}
                    </div>
                )}
                {Boolean(vnode.attrs.case_text) && (
                    <div className='case-quantity'>
                        <Icon name='case' size='s' type='unset' />
                        {vnode.attrs.case_text}
                    </div>
                )}
            </div>
        )
    }
}
